module.exports = vendors;